import type { Pill, Tone } from "../../model/invoice-view";

/**
 * Gemeinsame Bausteine der neu gegliederten Betreiber-Konsole (Vertrieb-Konsole, Inhaber 02.11.2026): Statuspille aus Text
 * und Ton (gleiche Zeichen wie die Pillen der Rechnungen).
 */
const ZEICHEN: Record<Tone, string> = { neutral: "○", info: "◇", warning: "◷", success: "✓", error: "!" };
export const pille = (label: string, tone: Tone): Pill => ({ label, tone, symbol: ZEICHEN[tone] });
